import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddMeetingRequest } from '../models/request/meeting/AddMeetingRequest';
import { GetMeetingListPagingAndFilterRequest } from '../models/request/meeting/GetMeetingListPagingAndFilterRequest';

export class MeetingService {
    static async getMeetingList() {
        try {
            var inputObj = {

            };

            console.log('SERVICE CALL - getMeetingList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Meeting/getMeetingList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportMeetingList(inputObj: GetMeetingListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportMeetingList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Meeting/exportMeetingList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getMeetingListPagingAndFilter(inputObj: GetMeetingListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetMeetingListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Meeting/GetMeetingListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static getFormData(obj: any = {}, formData = new FormData(), key = '') {
        if (!([Array, File, Object].includes(obj.constructor))) {
            return formData;
        }

        // Handle File recursive
        if (obj instanceof File) {
            formData.append(key, obj);
            return formData;
        }

        for (const prop in obj) {
            // Validate value type
            if (obj[prop] && !([String, Number, Boolean, Array, Object, File].includes(obj[prop].constructor))) {
                continue;
            }

            // Set deep index of prop
            const deepKey = key ? key + `.${prop}` : prop;

            // Handle array
            if (Array.isArray(obj[prop])) {
                obj[prop].forEach((item: any, index: any) => {
                    this.getFormData(item, formData, `${deepKey}[${index}]`);
                })
                continue;
            }

            (typeof obj[prop] === 'object' && obj[prop] && obj[prop].constructor === Object)
                ? this.getFormData(obj[prop], formData, deepKey) // Handle object
                : formData.append(deepKey, [undefined, null].includes(obj[prop]) ? '' : obj[prop]) // Handle string, number, boolean
        }

        return formData;
    }

    static async addMeeting(inputObj: AddMeetingRequest) {
        try {
            const formData = this.getFormData(inputObj);

            console.log('SERVICE CALL - AddMeeting', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Meeting/AddMeeting', formData);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteMeeting(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteMeeting', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Meeting/deleteMeeting', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getMeetingById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getMeetingById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Meeting/getMeetingById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}